module.exports = __webpack_public_path__ + "img/stock5.aab91bbd.png";